import React from "react";

import Post from "../components/Post";

function Blog(props) {
  return (
    <div className="flex md:justify-between justify-center flex-wrap items-center w-[88%] mx-auto pt-5 pb-5">
      {props.posts.map((post) => {
        return (
          <div key={post._id}>
            <Post post={post} />;
          </div>
        );
      })}
    </div>
  );
}

export default Blog;
